import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "../../App";
import { resolveBackFallbackPath } from "../../utils/navigation";

const BackNavigationButton = ({
  label = "Volver al dashboard",
  fallbackPath,
  onBeforeNavigate,
  className = "",
  dataTestId,
}) => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleBack = () => {
    if (onBeforeNavigate && !onBeforeNavigate()) {
      return;
    }

    if (window.history.length > 1) {
      navigate(-1);
      return;
    }

    navigate(resolveBackFallbackPath(user, fallbackPath));
  };

  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      onClick={handleBack}
      className={`gap-2 ${className}`.trim()}
      data-testid={dataTestId}
    >
      <ChevronLeft className="w-4 h-4" />
      {label}
    </Button>
  );
};

export default BackNavigationButton;
